module.exports = __webpack_public_path__ + "static/ridings-sm-bd2c81db935d7557e594877491f0b770.jpg";